// ----------------------
// CONSTANTS
// ----------------------
const ZONE_KEY = "user_zone";
const PINCODE_KEY = "user_pincode";
const closeBtn = document.querySelector(".pincode-popup__close-btn");
const popupOverlay = document.querySelector(".pincode-backdrop");


// ----------------------
// UI HELPERS
// ----------------------
function updateCurrentPincodeUI(pincode) {
  const el = document.querySelector(".current-pincode-information");
  if (!el || !pincode) return;

  el.innerHTML = `Delivering to&nbsp;<span>${pincode}</span>`;
  const span = el.querySelector("span");
  if (span) span.onclick = showPincodePopup;
}

function applyZonePricing(zone) {
  const validZones = ["North", "South", "East", "West"];
  const finalZone = validZones.includes(zone) ? zone : "Default";

  document.querySelectorAll(".price--zone").forEach(el => {
    el.setAttribute("data-price-zone", finalZone);
  });
}

function showPincodeError(message) {
  const el = document.querySelector(".pincode-error");
  if (!el) return;

  el.textContent = message;
  el.style.display = "block";
}

function clearPincodeError() {
  const el = document.querySelector(".pincode-error");
  if (!el) return;

  el.textContent = "";
  el.style.display = "none";
}


// ----------------------
// CART HELPERS (SOURCE OF TRUTH)
// ----------------------
async function getCartAttributes() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    return cart?.attributes || {};
  } catch (err) {
    console.error("Failed to fetch cart", err);
    return {};
  }
}

async function updateCartAttributes(zone, pincode) {
  return fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: { zone, pincode }
    })
  });
}


// ----------------------
// STORAGE SYNC
// ----------------------
function syncLocalStorage(zone, pincode) {
  if (zone) localStorage.setItem(ZONE_KEY, zone);
  if (pincode) localStorage.setItem(PINCODE_KEY, pincode);
}

function syncUI(zone, pincode) {
  updateCurrentPincodeUI(pincode);
  applyZonePricing(zone || "Default");
}


// ----------------------
// API
// ----------------------
async function resolveZoneWithPincode(pincode) {
  const res = await fetch(
    "https://pincodeutility.orientelectric.com/api/zone/resolve",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pincode })
    }
  );

  return res.json();
}


// ----------------------
// POPUP CONTROL
// ----------------------
function showPincodePopup() {
  const popup = document.getElementById("pincode-popup");
  if (popup) popup.style.display = "flex";
}

function hidePincodePopup() {
  sessionStorage.setItem("pincode_popup_shown", "true");
  const popup = document.getElementById("pincode-popup");
  if (popup) popup.style.display = "none";
}


// ----------------------
// SAVE FLOW (CART FIRST, ONLY WHEN VALID)
// ----------------------
async function saveUserZoneData(zone, pincode) {
  try {
    await updateCartAttributes(zone, pincode);
    syncLocalStorage(zone, pincode);
    syncUI(zone, pincode);

    document.dispatchEvent(
      new CustomEvent("pincode:updated", {
        detail: { zone, pincode }
      })
    );
  } catch (err) {
    console.error("Failed to save zone data", err);
  }
}


// ----------------------
// INIT FLOW (CART → STORAGE → UI)
// ----------------------
async function initZoneResolve() {
  const cartAttributes = await getCartAttributes();
  const cartZone = cartAttributes.zone;
  const cartPincode = cartAttributes.pincode;

  // 1️⃣ Cart is source of truth
  if (cartPincode) {
    syncLocalStorage(cartZone || "Default", cartPincode);
    syncUI(cartZone || "Default", cartPincode);
    return;
  }

  // 2️⃣ Fallback: localStorage → cart
  const storedZone = localStorage.getItem(ZONE_KEY);
  const storedPincode = localStorage.getItem(PINCODE_KEY);

  if (storedPincode) {
    await saveUserZoneData(storedZone || "Default", storedPincode);
    return;
  }

  // 3️⃣ Nothing exists → force input
  applyZonePricing("Default");
  if (!sessionStorage.getItem("pincode_popup_shown")){
    showPincodePopup();
  }
}


// ----------------------
// PINCODE SUBMIT HANDLER
// ----------------------
document.addEventListener("click", async (e) => {
  if (!e.target.matches("#submit-pincode")) return;

  const input = document.getElementById("pincode-input");
  const pincode = input?.value.trim();

  clearPincodeError();

  // 1️⃣ Strict format validation
  if (!/^[0-9]{6}$/.test(pincode)) {
    showPincodeError("Please enter a valid 6-digit pincode");
    return;
  }

  try {
    const apiResult = await resolveZoneWithPincode(pincode);

    // 2️⃣ Explicit non-serviceable check
    if (
      apiResult?.success &&
      apiResult?.data &&
      apiResult.data.serviceable === false
    ) {
      showPincodeError("This pincode is not serviceable");
      return;
    }

    // 3️⃣ Valid & serviceable
    if (apiResult?.success && apiResult?.data?.zone) {
      const { zone, pincode: resolvedPincode } = apiResult.data;
      await saveUserZoneData(zone, resolvedPincode);
      hidePincodePopup();
      return;
    }

    // 4️⃣ API responded but unusable
    showPincodeError("This pincode is not servicable.");

  } catch (err) {
    // 5️⃣ Network / server failure
    console.error("Pincode resolve failed", err);
    showPincodeError("Something went wrong. Please try again later.");
  }
});

if (closeBtn) {
  closeBtn.addEventListener("click", () => {
    hidePincodePopup();
  });
}

if (popupOverlay) {
  popupOverlay.addEventListener("click", (e) => {
    hidePincodePopup();
  });
}


// ----------------------
// START
// ----------------------
initZoneResolve();
